"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lp_components_1 = require("lp-components");
const react_1 = require("react");
const components_1 = require("components");
const utils_1 = require("utils");
const RadioButtonEditableInput_1 = __importDefault(require("./RadioButtonEditableInput"));
function ContactPatientRadioGroup({ ...props }) {
    const email = props?.options?.email;
    const sms = props?.options?.sms != undefined
        ? (0, utils_1.removeNonDigits)(props?.options?.sms)
        : undefined;
    const onChange = props.input.onChange;
    return ((0, jsx_runtime_1.jsxs)("fieldset", { className: "RadioGroup", children: [sms != undefined && ((0, jsx_runtime_1.jsx)(RadioButtonEditableInput_1.default, { id: "patientContactOptions.sms", radioGroupName: "patientContactOptions", initialValue: sms, onChange: onChange, format: utils_1.formatPhoneNumber, labelPrefix: "SMS: ", labelSuffix: "standard message and data rates may\n            apply", editField: {
                    name: 'primaryPhone',
                    placeholder: 'Mobile Number',
                    parse: utils_1.removeNonDigits,
                    inputType: lp_components_1.MaskedInput,
                    component: components_1.InputTip,
                    maskOptions: {
                        numericOnly: true,
                        blocks: [0, 3, 3, 4],
                        delimiters: ['(', ') ', '-'],
                    },
                } })), (0, jsx_runtime_1.jsx)(RadioButtonEditableInput_1.default, { id: "patientContactOptions.email", checked: true, radioGroupName: "patientContactOptions", initialValue: email, labelPrefix: "Email: ", labelSuffix: "", onChange: onChange, editField: {
                    name: 'email',
                    inputType: 'email',
                    component: lp_components_1.Input,
                    placeholder: 'Email Address',
                } })] }));
}
exports.default = (0, react_1.memo)(ContactPatientRadioGroup);
